export default {
  id: null,
  descricao: null,
  dataInicial: null,
  dataFinal: null,
  pdrRelatorioMediaFuncionario: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/pdrreportvaluationmembermodel.js